import { useEffect, useMemo, useState } from 'react'
import { addUpgradeReason, hasFeature } from '../../../../utils/general'
import { getTrackedLinksAnalytics } from '../../../../services/tracked-links'
import { onUpgradePlan } from '../../../../utils/general'
import { PLANS } from '../../../../constants/plans'
import { F_TRACKED_LINKS } from '../../../../constants/plans/constants'
import { useDispatch, useSelector } from 'react-redux'

export const useAnalyticsTracked = ({ domain }) => {
  const userProfile = useSelector((state) => state.manage.userProfile) || {}
  const productId = userProfile.productId || null
  const hasAccess = useMemo(() => {
    return hasFeature(productId, F_TRACKED_LINKS)
  }, [productId])

  const dispatch = useDispatch()
  const [trackedLinks, setTrackedLinks] = useState([])
  const [isLoadingLinks, setIsLoadingLinks] = useState(false)

  const getTrackedLinksList = async () => {
    setIsLoadingLinks(true)
    try {
      const data = await getTrackedLinksAnalytics(domain)
      setTrackedLinks(data)
    } catch (error) {
      setTrackedLinks([])
    } finally {
      setIsLoadingLinks(false)
    }
  }

  useEffect(() => {
    if (domain && hasAccess) {
      getTrackedLinksList()
    }
  }, [])

  const handleUpgrade = () => {
    addUpgradeReason('View Tracked Links')
    onUpgradePlan({ planId: PLANS.PRO.id, userProfile }, dispatch)
  }

  const hasLinks = trackedLinks && trackedLinks.length > 0

  return {
    trackedLinks,
    isLoadingLinks,
    hasLinks,
    handleUpgrade
  }
}
